import { useState, useCallback } from 'react';

export interface NotificationData {
    id: string;
    type: 'success' | 'error' | 'info' | 'warning';
    title: string;
    message: string;
    duration?: number;
}

export const useNotificationState = () => {
    const [notifications, setNotifications] = useState<NotificationData[]>([]);

    const addNotification = useCallback((notification: Omit<NotificationData, 'id'>) => {
        const id = Math.random().toString(36).substr(2, 9);
        setNotifications(prev => [...prev, { ...notification, id }]);
    }, []);

    const removeNotification = useCallback((id: string) => {
        setNotifications(prev => prev.filter(n => n.id !== id));
    }, []);

    return {
        notifications,
        addNotification,
        removeNotification
    };
};